/**
 * Asynchronously loads the component for NotFoundPage
 */
import loadable from '@loadable/component';

export default loadable(() => import('./component'));
